import type {
	ActiveInlineCommentsQueryType,
	CommentLocation,
	CommentReply,
} from '@confluence/inline-comments-queries';

import type { CommentData } from '../useCommentsData';

export const updateCommentsDataState = ({
	data,
	readCommentsListState,
	updateInlineCommentsDataMap,
	updateIsLoadedStatus,
}: {
	data: ActiveInlineCommentsQueryType;
	readCommentsListState: Set<string>;
	updateInlineCommentsDataMap: (annotation: string, comment: CommentData) => void;
	updateIsLoadedStatus: (loadedAnnotationIds: string[]) => void;
}) => {
	// update each annotation loaded status and build our source of truth for inline comments
	const fetchedAnnotationIds: string[] = [];
	data?.comments?.nodes?.forEach((comment) => {
		if (comment) {
			const markerRef = (comment.location as CommentLocation).inlineMarkerRef;
			if (markerRef) {
				updateInlineCommentsDataMap(markerRef, {
					...comment,
					isUnread: !readCommentsListState.has(comment.id),
					isOpen: true,
					replies: (comment.replies as CommentReply[]).map((reply) => ({
						...reply,
						isUnread: !!(reply && !readCommentsListState.has(reply.id)),
					})),
				});
				fetchedAnnotationIds.push(markerRef);
			}
		}
	});
	if (fetchedAnnotationIds.length > 0) {
		updateIsLoadedStatus(fetchedAnnotationIds);
	}
};
